import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col h-52 p-4 min-w-336" }
const _hoisted_2 = { class: "flex-grow" }
const _hoisted_3 = { class: "flex-shrink text-sm" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "basis-1/2 flex flex-col items-start"
}
const _hoisted_6 = { class: "flex-shrink text-2xl" }
const _hoisted_7 = {
  key: 1,
  class: "basis-1/2 flex flex-col items-start"
}
const _hoisted_8 = { class: "flex-shrink text-2xl" }
const _hoisted_9 = {
  key: 2,
  class: "flex items-center self-end"
}
const _hoisted_10 = {
  key: 3,
  class: "flex items-center self-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex flex-shrink font-bold" }, "Alert Manuale", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.descrizione), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.abilitato !== '0')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-shrink text-sm" }, "Scadenza", -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.scadenza), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-shrink text-sm" }, "Completato il", -1)),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.updated_at), 1)
          ])),
      (_ctx.abilitato !== '0')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("p", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update', _ctx.id))),
              class: "cursor-pointer underline ml-2"
            }, "Modifica"),
            _createVNode(_component_NextButton, {
              onClick: _ctx.changeState,
              variant: "outline-secondary",
              class: "basis-1/4 px-3 py-1 ml-3 whitespace-nowrap"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.label), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_NextButton, {
              variant: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', _ctx.id))),
              class: "basis-1/4 px-3 py-1 ml-3 whitespace-nowrap"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Elimina")
              ])),
              _: 1
            })
          ]))
    ])
  ]))
}